import { roundToThreeDecimals } from '../../../helpers/modules';
import { convertNumberToWords } from './billFunctions';
import logo from '../../../assets/jeunessee.png';
import React, { useEffect, useState } from 'react';

const PrintToPdf = ({
	componentRef,
	detailBill,
	billCalculationArr,
	totalNetValue,
	totalArr,
	isTunisia,
}) => {
	let itemsPerPage = [9, 15];
	const [countryMap, setCountryMap] = useState({});
	const [countryNames, setCountryNames] = useState({});

	useEffect(() => {
		fetch('https://cdn.jsdelivr.net/npm/world-countries@4/dist/countries.json')
			.then((res) => res.json())
			.then((data) => {
				const map = {};
				const names = {};
				data.forEach((c) => {
					if (c.cca3 && c.cca2) {
						map[c.cca3] = c.cca2.toLowerCase();
						names[c.cca3] = c.name.common;
					}
				});
				setCountryMap(map);
				setCountryNames(names);
			})
			.catch((err) => console.error('Failed to fetch country codes:', err));
	}, []);

	const getFlagUrl = (cca3) => {
		if (!cca3 || !countryMap[cca3]) return null;
		return `https://hatscripts.github.io/circle-flags/flags/${countryMap[cca3]}.svg`;
	};

	const getCountryName = (cca3) => {
		return countryNames[cca3] || cca3;
	};

	const shopCountry = detailBill?.bill?.order_id?.shopInfo?.country;
	const showTimbre = isTunisia !== undefined ? isTunisia : !shopCountry || shopCountry === 'TUN';

	const timbreCount = detailBill?.companies?.length || 1;
	const timbreTotal = showTimbre ? timbreCount * 1 : 0;

	if (Object.keys(detailBill).length === 0) {
		return;
	}

	const renderTableRows = (start, end) => {
		return detailBill?.list?.slice(start, end).map((item, index) => (
			<tr className='elements' key={index}>
				<td>{item?.reference}</td>
				<td>{item?.designation}</td>
				<td>{item?.company_name || '-'}</td>
				<td>{item?.quantity}</td>
				<td>
					{roundToThreeDecimals(
						(item?.prise_product_HT * item?.quantity) / (1 - item?.remise / 100),
					)}
				</td>
				<td>{item?.remise}%</td>
				<td>{roundToThreeDecimals(item?.prise_product_HT * item?.quantity)}</td>
				<td>{item?.tva}%</td>
			</tr>
		));
	};

	const renderTable = (start, end) => {
		return (
			<div key={start} className='page-content'>
				<div className='devis-table'>
					<table className='offres'>
						<thead>
							<tr id='titres'>
								<th>RÉFÉRENCE</th>
								<th>DÉSIGNATION</th>
								<th>SOCIÉTÉ</th>
								<th>QTÉ</th>
								<th>PRIX UNIT H.T</th>
								<th>REMISE</th>
								<th>MONTANT H.T</th>
								<th>TX.TVA</th>
							</tr>
						</thead>
						<tbody>{renderTableRows(start, end)}</tbody>
					</table>
				</div>
			</div>
		);
	};

	return (
		<div className='bill-pdf-client' ref={componentRef}>
			<div className='pdf-logo-container'>
				<img src={logo} alt='Logo' className='pdf-logo-img' />
			</div>

			<div className='container'>
				<div className='devis'>
					<h4>FACTURE Proformat</h4>
					<div className='info'>
						<div>
							<label>Numéro:</label>
							<label>Date:</label>
							<label>Référence code client:</label>
						</div>
						<div>
							<span>{detailBill?.bill?.reference}</span>
							<span>
								{detailBill?.bill?.createdAt
									? new Date(detailBill.bill.createdAt).toLocaleDateString('fr-FR')
									: '-'}
							</span>
							<span>{detailBill?.bill?.order_id?.clientInfo?.customs_code || '-'}</span>
						</div>
					</div>
				</div>
				<div className='general-info'>
					<div className='left'>
						<h2 className='infos-societe'>JEUN'ESS MARKET</h2>
						<div className='address'>
							<span>VTE EN GROS ART DE MENAGE</span>
						</div>
					</div>
					<div className='right'>
						<h3>{detailBill?.bill?.order_id?.clientInfo?.company_name ?? ''}</h3>
						<p>{detailBill?.bill?.order_id?.clientInfo?.client ?? ''}</p>
						<p>
							Matricule Fiscale:{' '}
							{detailBill?.bill?.order_id?.clientInfo?.tax_registration_number ?? ''}
						</p>
						<p>N° téléphone: {detailBill?.bill?.order_id?.clientInfo?.phone ?? ''}</p>
						<span>{detailBill?.bill?.order_id?.shopInfo?.address_number} </span>
						<span>{detailBill?.bill?.order_id?.shopInfo?.street} </span>
						<span>{detailBill?.bill?.order_id?.shopInfo?.ville} </span>
						<span>{detailBill?.bill?.order_id?.shopInfo?.postal_code} </span>
						<span>{detailBill?.bill?.order_id?.shopInfo?.region} </span>
						{shopCountry && (
							<div style={{ marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
								{getFlagUrl(shopCountry) && (
									<img
										src={getFlagUrl(shopCountry)}
										alt={getCountryName(shopCountry)}
										width='14'
										height='14'
										style={{ borderRadius: '50%' }}
									/>
								)}
								<span style={{ fontSize: '0.625rem', color: '#0f172a', fontWeight: 300 }}>
									{getCountryName(shopCountry)}
								</span>
							</div>
						)}
					</div>
				</div>

				<div className='devis-table'>
					{renderTable(0, itemsPerPage[0])}
					{Array.from(
						{ length: Math.ceil((detailBill?.list?.length - itemsPerPage[0]) / itemsPerPage[1]) },
						(_, index) =>
							renderTable(
								itemsPerPage[0] + index * itemsPerPage[1],
								itemsPerPage[0] + (index + 1) * itemsPerPage[1],
							),
					)}
					{detailBill?.list?.length >= 2 && <div style={{ pageBreakAfter: 'always' }} />}

					{detailBill?.companies && detailBill.companies.length > 0 && (
						<div className='companies-section-print'>
							<h3>Sociétés concernées</h3>
							{detailBill.companies.map((company, idx) => (
								<div key={idx} className='company-card-print'>
									<div className='company-header-print'>
										<strong>{company.name}</strong>
									</div>
									<div className='company-details-print'>
										<span>Adresse: {company.address}</span>
										<span>CODE TVA: {company.tva_code}</span>
										<span>RC: {company.r_c}</span>
										<span>Code en Douane: {company.customs_code}</span>
										<span>Tél: {company.phone}</span>
										<span>Fax: {company.fax}</span>
										<span>Email: {company.email}</span>
									</div>
								</div>
							))}
						</div>
					)}

					<div className='billTable'>
						<table id='bt-principal'>
							<tbody>
								<tr id='firstBigRow'>
									<td>
										<table id='bt-nested-1'>
											<thead>
												<tr id='bt-head-1'>
													<th>CODE</th>
													<th>BASE</th>
													<th>TAUX</th>
													<th>TOTAL TAXE</th>
												</tr>
											</thead>
											<tbody>
												{billCalculationArr?.map((el, index) => (
													<tr className='bt-tl-1' key={index}>
														<td>{el.CODE}</td>
														<td>{roundToThreeDecimals(el.BASE)}</td>
														<td>{el.TAUX}%</td>
														<td>{roundToThreeDecimals(el.TOTAL_TAXE)}</td>
													</tr>
												))}
												{showTimbre && (
													<tr className='bt-tl-1'>
														<td>CTI</td>
														<td>0.000</td>
														<td />
														<td>1 DT</td>
													</tr>
												)}
												{showTimbre && (
													<tr className='bt-tl-1'>
														<td>Timbres</td>
														<td>0.000 DT</td>
														<td></td>
														<td>{timbreTotal} DT</td>
													</tr>
												)}
											</tbody>
										</table>
									</td>
									<td>
										<table id='bt-nested-2'>
											<thead>
												<tr id='bt-head-2'>
													<th>TOTAL H.T</th>
													<th>REMISE</th>
													<th>ESCOMPTE</th>
													<th>TOTAL TTC</th>
												</tr>
											</thead>
											<tbody>
												{billCalculationArr?.map((el, index) => (
													<tr className='bt-tl-2' id='bt-tl-2' key={index}>
														<td>{roundToThreeDecimals(el.BASE)}</td>
														<td>{roundToThreeDecimals(el.REMISE)}</td>
														<td>0.000</td>
														<td>{roundToThreeDecimals(el.TOTAL_TCC)}</td>
													</tr>
												))}
												<tr className='bt-tl-2'>
													<td />
													<td />
													<td />
													<td />
												</tr>
											</tbody>
										</table>
									</td>
									<td>
										<table id='bt-nested-3'>
											<thead>
												<tr id='bt-head-3'>
													<th>NET A PAYER</th>
												</tr>
											</thead>
											<tbody>
												<tr className='bt-tl-3'>
													<td>{totalNetValue}</td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
								<tr id='secondBigRow'>
									<td>
										<table id='bt-nested-4'>
											<tbody>
												<tr className='bt-head-4'>
													<td />
													<td />
													<td />
													<td />
												</tr>
												<tr className='bt-head-4'>
													<td />
													<td />
													<td />
													<td />
												</tr>
												{totalArr}
											</tbody>
										</table>
									</td>
									<td>
										<table id='bt-nested-5'>
											<thead>
												<tr id='bt-head-5'>
													<th>CONDITIONS DE REGLEMENT:</th>
													<th />
												</tr>
											</thead>
											<tbody>
												<tr className='bt-tl-5'>
													<td />
													<td />
												</tr>
												<tr className='bt-tl-5'>
													<td>90 JOURS</td>
													<td />
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
						<div className='billEnd'>
							<h2>ARRETER LA PRÉSENTE FACTURE À LA SOMME DE : </h2>
							<span>{convertNumberToWords(parseInt(totalNetValue * 1000))}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PrintToPdf;
